/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import RoleFormPage from './RoleFormPage'
import RoleListPage from './RoleListPage'

export const roleRoutes: RouteObject[] = [
  {
    index: true,
    element: <RoleListPage />
  },
  {
    path: 'create',
    element: <RoleFormPage />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <RoleFormPage />
      }
    ]
  }
]
